import { Key } from "react";
import { ScanSummary } from "types/api/scanSummary";
import { DateFormatType } from "types/common";

import { ACTableProps } from "ac-components/ACTable/ACTable";
import ACResizableColumnCell from "ac-components/ac-resizable-column-cell/ACResizableColumnCell";

export const CommonTableProps: ACTableProps<ScanSummary> = {
  rowKey: "id",
  sticky: true,
  autoEnableScroll: true,
  computeTableWidth: true,
  components: {
    header: {
      cell: ACResizableColumnCell,
    },
  },
};

export const DEFAULT_HIDDEN_COLUMN_KEYS = [
  "product",
  "createdAt",
  "triggerby",
  "uploadedBy",
  "scanDate",
];

export const DEFAULT_DATE_FORMATS: Record<Key, DateFormatType> = {
  createdAt: "relativeTime",
  scanDate: "date",
};
